//
import FamilyModel from '@/models/Warehouse/WhFamily'
import SubfamilyModel from '@/models/Warehouse/WhSubfamily'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default [
    {
        name: 'alias_search',
        props: {
            label: 'Alias',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'internal_code',
        props: {
            label: 'Código Interno',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'upc_code',
        props: {
            label: 'Código UPC',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'of_warehouse',
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'wh_family_id',
        props: {
            chips: true,
            itemText: 'family',
            itemValue: 'id',
            label: 'Familia',
            model: FamilyModel,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'wh_subfamily_id',
        props: {
            chips: true,
            itemText: 'subfamily',
            itemValue: 'id',
            label: 'Sub Familia',
            model: SubfamilyModel,
            noObject: true,
            paramSearch: 'subfamily',
        },
        type: 'autocomplete-model',
    },
    {
        name: 'is_salable',
        props: {
            chips: true,
            items: [
                {
                    text: 'No',
                    value: 0,
                },
                {
                    text: 'Si',
                    value: 1,
                },
            ],
            label: 'Vendible',
        },
        type: 'select',
        value: '',
    },
    {
        name: 'is_repackaged',
        props: {
            chips: true,
            items: [
                {
                    text: 'No',
                    value: 0,
                },
                {
                    text: 'Si',
                    value: 1,
                },
            ],
            label: 'Reenvasable',
        },
        type: 'select',
        value: '',
    },
    {
        name: 'is_consumable',
        props: {
            chips: true,
            items: [
                {
                    text: 'No',
                    value: 0,
                },
                {
                    text: 'Si',
                    value: 1,
                },
            ],
            label: 'Consumible',
        },
        type: 'select',
        value: '',
    },
    {
        name: "product_provider_code",
        type: "text-field",
        props: {
            label: "Codigo de proveedor",
        },
    },  
]

//error: "Given filter(s) `op` are not allowed. Allowed filter(s) are `search, alias_search, wh_product_ids, of_warehouse, critical_stock_by_warehouse, wh_family_id, wh_families_id, wh_subfamilies_id, tags_id, tags, upc_code, is_repacking_parent, internal_code, name, alias_name, is_salable, is_repackaged, wh_subfamily_id, type, types, is_consumable, pch_provider_id`."
